import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { courseSkillsTable } from '@/mocks/skillsData';

const COURSE_COUNT = 3;

export default function CourseSkillsTable() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {String(t('skills.table.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('skills.table.title')}
          </h2>
          {String(t('skills.table.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('skills.table.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed mt-5 max-w-[600px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {Array.from({ length: COURSE_COUNT }, (_, idx) => (
            <div
              key={idx}
              className="card-glow group bg-background-100/60 border border-background-200/60 p-6 cursor-pointer flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-500/10 flex-shrink-0">
                  <i className={`${courseSkillsTable.courses[idx].icon} text-accent-500 text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] group-hover:text-accent-600 transition-colors">
                    {t(`skills.table.${idx}.name`)}
                  </h3>
                  <p className="text-[13px] text-foreground-400 tracking-[0.06em]">
                    {courseSkillsTable.courses[idx].nameEn}
                  </p>
                </div>
              </div>

              <p className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed mb-3 flex-grow">
                {t(`skills.table.${idx}.details`)}
              </p>

              <div className="flex items-center justify-between mt-auto pt-4 border-t border-background-200/40">
                <span className="text-[13px] text-accent-600 tracking-[0.06em]">
                  {t(`skills.table.${idx}.scope`)}
                </span>
                <Link
                  to={courseSkillsTable.courses[idx].href}
                  className="inline-flex items-center gap-1 text-[14px] text-accent-500 hover:text-accent-400 tracking-[0.05em] transition-colors whitespace-nowrap"
                >
                  {t('skills.table.viewDetail')}
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-[12px]"></i>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
